<div class="list-page kapea" style="min-width: 70vw">
  <div class="card-wrapper">
    <div class="card-header">
      <h2>Maksumuistuksien massalähetys</h2>
      @if (aktiivinenValilehti === 0) {
        <p class="card-subtitle">Huom! 1. Listauksesta puuttuu laskut, joissa avoinna alle 10 €</p>
      }
      @if (aktiivinenValilehti === 1) {
        <p class="card-subtitle">Huom! 2. Listauksesta puuttuu laskut, joissa avoinna alle 50 €</p>
      }
    </div>

    <mat-tab-group [(selectedIndex)]="aktiivinenValilehti" (selectedIndexChange)="vaihdaValilehti($event)">
      <mat-tab label="1. muistutus"></mat-tab>
      <mat-tab label="2. muistutus (Perintäritari)"></mat-tab>
      <mat-tab label="Työkiellossa olevat"></mat-tab>
      <mat-tab label="Työkielto asetettava"></mat-tab>
      <mat-tab label="Purku-uhka"></mat-tab>
      <mat-tab label="Lopettaneet (työkielto)"></mat-tab>
    </mat-tab-group>

    @if (aktiivinenValilehti <= 1) {
      <div style="position: relative">
        <mat-table class="laskut-table" matSort [dataSource]="aktiivinenDataSource" [matSortDisableClear]="true" [trackBy]="trackLaskuByAvain" style="min-height: 160px">
          <ng-container matColumnDef="nro">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'laskut.numero' | translate | async }} </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.nro }} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="asiakas">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'laskut.asiakas' | translate | async }} </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.asiakas }} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="erapvm">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'laskut.erapaiva' | translate | async }} </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.erapvm | lokaalipvm | async }} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="lataa">
            <mat-header-cell *matHeaderCellDef>Poista listalta</mat-header-cell>
            <mat-cell *matCellDef="let row">
              @if (row.tyyppi == 't' || row.tyyppi == 'v') {
                <app-button (click)="poistaListalta(row); $event.stopPropagation()" actionId="Poista maksumuistutuksien listalta" styles="margin: 0; min-width: 32px; padding: 0 2px;"> X </app-button>
                <app-button (click)="poistaKaikkiListalta(row); $event.stopPropagation()" actionId="Poista kaikki maksumuistutuksien listalta" styles="margin: 0; min-width: 32px; padding: 0 2px;"> X 2 </app-button>
              }
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="pvm">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'laskut.laskun-pvm' | translate | async }} </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.pvm | lokaalipvm | async }} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="summa">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'laskut.summa' | translate | async }} </mat-header-cell>
            <mat-cell *matCellDef="let row"> {{ row.summa | lmoney: row.valuutta | async }} </mat-cell>
          </ng-container>
          <ng-container matColumnDef="kommentti">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'laskut.kommentti' | translate | async }} </mat-header-cell>
            <mat-cell *matCellDef="let row">
              @if ((row.tyyppi == 'v' || row.tyyppi == 't') && row.tila !== 'lu') {
                {{ row.juurilasku.kommentti }}
              }
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="ennakkolasku">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'laskut.ennakkolasku' | translate | async }} </mat-header-cell>
            <mat-cell *matCellDef="let row">
              @if (row.juurilasku.ennakkolasku) {
                <span>✓</span>
              }
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="avoinna">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'laskut.avoinna' | translate | async }} </mat-header-cell>
            <mat-cell *matCellDef="let row">
              @if ((row.tyyppi == 'v' || row.tyyppi == 't') && row.tila !== 'lu') {
                {{ row.avoinna | lmoney: row.valuutta | async }}
              }
            </mat-cell>
          </ng-container>
          <ng-container matColumnDef="tila">
            <mat-header-cell *matHeaderCellDef mat-sort-header> {{ 'laskut.tila' | translate | async }} </mat-header-cell>
            <mat-cell *matCellDef="let row" [class.blue-text]="row.vari == 'blue'" [class.yellow-text]="row.vari == 'yellow'" [class.green-text]="row.vari == 'green'" [class.red-text]="row.vari == 'red'" [class.purple-text]="row.vari == 'purple'" [class.mint-text]="row.vari == 'mint'">
              @if (row.tyyppi == 't' || row.tyyppi == 'v') {
                {{ 'lasku.tila.' + row.tila | translate | async }}
              }
            </mat-cell>
          </ng-container>
          <mat-header-row *matHeaderRowDef="propertiesToDisplay()"></mat-header-row>
          <mat-row *matRowDef="let row; columns: propertiesToDisplay()" [class.lemon-lapsi]="row.tyyppi == 'l'" [class.lemon-lapsi-viimeinen]="row.tyyppi == 'lv'" [class.lemon-vanhempi]="row.tyyppi == 'v'"></mat-row>
        </mat-table>
        @if (!lataa() && matDataSource.filteredData?.length == 0) {
          <div class="table-ladataan">
            <div class="empty-state">
              {{ 'laskut.hakuehdoilla-ei-yhtaan-tulosta' | translate | async }}
            </div>
          </div>
        }
        <div lemon-loading [config]="loadingSettings" [show]="lataa()"></div>
      </div>
    }

    @if (aktiivinenValilehti <= 1) {
      <div class="invoice-count"><strong>Laskujen määrä:</strong> {{ laskujenMaara }} kpl</div>
    }

    @if (aktiivinenValilehti <= 1) {
      <div class="action-buttons">
        <app-primary-button (click)="lahetaMuistutuslaskut()" actionId="Lähetä muistutuslaskut (ylläpito)" additionalClass="mat-elevation-z4" matIcon="email"> Lähetä {{ aktiivinenValilehti === 0 ? '1.' : '2.' }} muistutuslaskut </app-primary-button>
      </div>
    }

    <!-- Yhteinen kääre työkielto-välilehdille: latausanimaatio ei saa syntyä vasta välilehteä vaihdettaessa, koska lataus on silloin jo ohi -->
    <div style="position: relative">
      <!-- Tab 2: Työkiellossa olevat -->
      @if (aktiivinenValilehti === 2) {
        <div style="margin-top: 16px">
          <mat-table class="laskut-table" matSort #tab2Sort="matSort" [matSortDisableClear]="true" [dataSource]="_tab2DataSource" [trackBy]="trackTyokieltoByAvain" style="min-height: 160px">
            <ng-container matColumnDef="asiakasNimi">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Asiakas</mat-header-cell>
              <mat-cell *matCellDef="let rivi"
                ><a [routerLink]="['/asiakkaat', rivi.asiakasAvain, 'laskutus']">{{ rivi.asiakasNimi }}</a></mat-cell
              >
            </ng-container>
            <ng-container matColumnDef="laskujenMaara">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Erääntyneitä laskuja</mat-header-cell>
              <mat-cell *matCellDef="let rivi">{{ rivi.laskujenMaara }} kpl</mat-cell>
            </ng-container>
            <ng-container matColumnDef="tyokieltoAlku">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Työkielto asetettu</mat-header-cell>
              <mat-cell *matCellDef="let rivi">{{ tyokieltoAlkuMap().get(rivi.asiakasAvain) | ltimestamptime | async }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="toiminnot">
              <mat-header-cell *matHeaderCellDef>Toiminnot</mat-header-cell>
              <mat-cell *matCellDef="let rivi">
                <app-secondary-button (click)="avaaTyokieltoDialogAsiakkaalle(rivi)" actionId="Lopeta työkielto (työkiellossa olevat)" matIcon="block"> Lopeta työkielto </app-secondary-button>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="piilota">
              <mat-header-cell *matHeaderCellDef>Poista listalta</mat-header-cell>
              <mat-cell *matCellDef="let rivi">
                <app-button (click)="piilotaTyokiellossaOlevaListalta(rivi); $event.stopPropagation()" actionId="Piilota työkiellossa olevat -listalta" styles="margin: 0; min-width: 32px; padding: 0 2px;"> X </app-button>
                <app-button (click)="piilotaKaikkiMuutTyokiellossaOlevatListalta(rivi); $event.stopPropagation()" actionId="Piilota kaikki muut työkiellossa olevat -listalta" styles="margin: 0; min-width: 32px; padding: 0 2px;"> X 2 </app-button>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="tyokiellossaOlevatColumnsToDisplay"></mat-header-row>
            <mat-row *matRowDef="let rivi; columns: tyokiellossaOlevatColumnsToDisplay"></mat-row>
          </mat-table>
          @if (!lataaTyokielto() && tyokieltoAsiakkaatTyokiellossa.length === 0) {
            <div class="table-ladataan">
              <div class="empty-state">Ei asiakkaita työkiellossa</div>
            </div>
          }
        </div>
      }

      <!-- Tab 3: Työkielto asetettava -->
      @if (aktiivinenValilehti === 3) {
        <div style="margin-top: 16px">
          <mat-table class="laskut-table" matSort #tab3Sort="matSort" [matSortDisableClear]="true" [dataSource]="_tab3DataSource" [trackBy]="trackTyokieltoByAvain" style="min-height: 160px">
            <ng-container matColumnDef="asiakasNimi">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Asiakas</mat-header-cell>
              <mat-cell *matCellDef="let rivi"
                ><a [routerLink]="['/asiakkaat', rivi.asiakasAvain, 'laskutus']">{{ rivi.asiakasNimi }}</a></mat-cell
              >
            </ng-container>
            <ng-container matColumnDef="laskujenMaara">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Erääntyneitä laskuja</mat-header-cell>
              <mat-cell *matCellDef="let rivi">{{ rivi.laskujenMaara }} kpl</mat-cell>
            </ng-container>
            <ng-container matColumnDef="toiminnot">
              <mat-header-cell *matHeaderCellDef>Toiminnot</mat-header-cell>
              <mat-cell *matCellDef="let rivi">
                @if (!tyokieltoStatus().get(rivi.asiakasAvain)) {
                  <app-secondary-button (click)="avaaTyokieltoDialogAsiakkaalle(rivi)" actionId="Aseta työkieltoon (maksumuistutus)" matIcon="block"> Aseta työkieltoon </app-secondary-button>
                }
                @if (tyokieltoStatus().get(rivi.asiakasAvain)) {
                  <app-secondary-button (click)="avaaTyokieltoDialogAsiakkaalle(rivi)" actionId="Lopeta työkielto (maksumuistutus)" matIcon="block"> Lopeta työkielto </app-secondary-button>
                }
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="piilota">
              <mat-header-cell *matHeaderCellDef>Poista listalta</mat-header-cell>
              <mat-cell *matCellDef="let rivi">
                <app-button (click)="piilotaTyokieltoListalta(rivi); $event.stopPropagation()" actionId="Piilota työkielto-listalta" styles="margin: 0; min-width: 32px; padding: 0 2px;"> X </app-button>
                <app-button (click)="piilotaKaikkiMuutTyokieltoListalta(rivi); $event.stopPropagation()" actionId="Piilota kaikki muut työkielto-listalta" styles="margin: 0; min-width: 32px; padding: 0 2px;"> X 2 </app-button>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="tyokieltoColumnsToDisplay"></mat-header-row>
            <mat-row *matRowDef="let rivi; columns: tyokieltoColumnsToDisplay"></mat-row>
          </mat-table>
          @if (!lataaTyokielto() && tyokieltoAsiakkaatIlmanTyokieltoa.length === 0) {
            <div class="table-ladataan">
              <div class="empty-state">Ei asiakkaita, joilla 2 erääntynyttä laskua ilman työkieltoa</div>
            </div>
          }
        </div>
      }

      <!-- Tab 4: Purku-uhka -->
      @if (aktiivinenValilehti === 4) {
        <div style="margin-top: 16px">
          <mat-table class="laskut-table" matSort #tab4Sort="matSort" [matSortDisableClear]="true" [dataSource]="_tab4DataSource" [trackBy]="trackTyokieltoByAvain" style="min-height: 160px">
            <ng-container matColumnDef="asiakasNimi">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Asiakas</mat-header-cell>
              <mat-cell *matCellDef="let rivi"
                ><a [routerLink]="['/asiakkaat', rivi.asiakasAvain, 'laskutus']">{{ rivi.asiakasNimi }}</a></mat-cell
              >
            </ng-container>
            <ng-container matColumnDef="laskujenMaara">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Erääntyneitä laskuja</mat-header-cell>
              <mat-cell *matCellDef="let rivi">{{ rivi.laskujenMaara }} kpl</mat-cell>
            </ng-container>
            <ng-container matColumnDef="tyokielto">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Työkielto päällä</mat-header-cell>
              <mat-cell *matCellDef="let rivi">{{ tyokieltoStatus().get(rivi.asiakasAvain) ? 'Kyllä' : 'Ei' }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="tyokieltoAlku">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Työkielto asetettu</mat-header-cell>
              <mat-cell *matCellDef="let rivi">
                @if (tyokieltoAlkuMap().get(rivi.asiakasAvain); as alku) {
                  {{ alku | ltimestamptime | async }}
                } @else {
                  -
                }
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="toiminnot">
              <mat-header-cell *matHeaderCellDef>Toiminnot</mat-header-cell>
              <mat-cell *matCellDef="let rivi">
                @if (!tyokieltoStatus().get(rivi.asiakasAvain)) {
                  <app-secondary-button (click)="avaaTyokieltoDialogAsiakkaalle(rivi)" actionId="Aseta työkieltoon purku-uhka (maksumuistutus)" matIcon="block"> Aseta työkieltoon </app-secondary-button>
                }
                @if (tyokieltoStatus().get(rivi.asiakasAvain)) {
                  <app-secondary-button (click)="avaaTyokieltoDialogAsiakkaalle(rivi)" actionId="Lopeta työkielto purku-uhka (maksumuistutus)" matIcon="block"> Lopeta työkielto </app-secondary-button>
                }
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="piilota">
              <mat-header-cell *matHeaderCellDef>Poista listalta</mat-header-cell>
              <mat-cell *matCellDef="let rivi">
                <app-button (click)="piilotaTyokieltoListalta(rivi); $event.stopPropagation()" actionId="Piilota purku-uhka-listalta" styles="margin: 0; min-width: 32px; padding: 0 2px;"> X </app-button>
                <app-button (click)="piilotaKaikkiMuutTyokieltoListalta(rivi); $event.stopPropagation()" actionId="Piilota kaikki muut purku-uhka-listalta" styles="margin: 0; min-width: 32px; padding: 0 2px;"> X 2 </app-button>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="purkuUhkaColumnsToDisplay"></mat-header-row>
            <mat-row *matRowDef="let rivi; columns: purkuUhkaColumnsToDisplay"></mat-row>
          </mat-table>
          @if (!lataaTyokielto() && purkuUhkaAsiakkaatFiltered.length === 0) {
            <div class="table-ladataan">
              <div class="empty-state">Ei asiakkaita, joilla 3 tai enemmän erääntynyttä laskua</div>
            </div>
          }
        </div>
      }

      <!-- Tab 5: Lopettaneet, joilla työkielto edelleen päällä -->
      @if (aktiivinenValilehti === 5) {
        <div style="margin-top: 16px">
          <mat-table class="laskut-table" matSort #tab5Sort="matSort" [matSortDisableClear]="true" [dataSource]="_tab5DataSource" [trackBy]="trackTyokieltoByAvain" style="min-height: 160px">
            <ng-container matColumnDef="asiakasNimi">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Asiakas</mat-header-cell>
              <mat-cell *matCellDef="let rivi"
                ><a [routerLink]="['/asiakkaat', rivi.asiakasAvain, 'laskutus']">{{ rivi.asiakasNimi }}</a></mat-cell
              >
            </ng-container>
            <ng-container matColumnDef="laskujenMaara">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Erääntyneitä laskuja</mat-header-cell>
              <mat-cell *matCellDef="let rivi">{{ rivi.laskujenMaara }} kpl</mat-cell>
            </ng-container>
            <ng-container matColumnDef="avoinSumma">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Avoinna</mat-header-cell>
              <mat-cell *matCellDef="let rivi">{{ rivi.avoinSumma | lmoney: 'EUR' | async }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="lopetusPvm">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Sopimus päättyi</mat-header-cell>
              <mat-cell *matCellDef="let rivi">
                @if (rivi.lopetusPvm) {
                  {{ rivi.lopetusPvm | lokaalipvm | async }}
                } @else {
                  -
                }
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="lopettamisenSyy">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Lopettamisen syy</mat-header-cell>
              <mat-cell *matCellDef="let rivi">{{ annaLopettamisenSyy(rivi) }}</mat-cell>
            </ng-container>
            <ng-container matColumnDef="tyokieltoAlku">
              <mat-header-cell *matHeaderCellDef mat-sort-header>Työkielto asetettu</mat-header-cell>
              <mat-cell *matCellDef="let rivi">
                @if (rivi.tyokieltoAlku) {
                  {{ rivi.tyokieltoAlku | ltimestamptime | async }}
                } @else {
                  -
                }
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="toiminnot">
              <mat-header-cell *matHeaderCellDef>Toiminnot</mat-header-cell>
              <mat-cell *matCellDef="let rivi">
                <app-secondary-button (click)="avaaTyokieltoDialogAsiakkaalle(rivi)" actionId="Lopeta työkielto (lopettaneet)" matIcon="block"> Lopeta työkielto </app-secondary-button>
              </mat-cell>
            </ng-container>
            <ng-container matColumnDef="piilota">
              <mat-header-cell *matHeaderCellDef>Poista listalta</mat-header-cell>
              <mat-cell *matCellDef="let rivi">
                <app-button (click)="piilotaLopettanutListalta(rivi); $event.stopPropagation()" actionId="Piilota lopettaneet-listalta" styles="margin: 0; min-width: 32px; padding: 0 2px;"> X </app-button>
                <app-button (click)="piilotaKaikkiMuutLopettaneetListalta(rivi); $event.stopPropagation()" actionId="Piilota kaikki muut lopettaneet-listalta" styles="margin: 0; min-width: 32px; padding: 0 2px;"> X 2 </app-button>
              </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="lopettaneetColumnsToDisplay"></mat-header-row>
            <mat-row *matRowDef="let rivi; columns: lopettaneetColumnsToDisplay"></mat-row>
          </mat-table>
          @if (!lataaTyokielto() && lopettaneetRivit().length === 0) {
            <div class="table-ladataan">
              <div class="empty-state">Ei lopettaneita asiakkaita työkiellossa</div>
            </div>
          }
        </div>
      }

      <div lemon-loading [config]="loadingSettings" [show]="aktiivinenValilehti >= 2 && lataaTyokielto()"></div>
    </div>

    @if (lahetysVirheet().length > 0) {
      <div class="error-wrapper">
        <div class="error-header">Lähetysvirheet</div>
        <p class="error-subtitle">Näkyvissä vain kyseisen lähetyksen jälkeen</p>
        <ul class="error-list">
          @for (virhe of lahetysVirheet(); track virhe) {
            <li>
              {{ virhe?.error?.message || 'Tuntematon virhe' }}
              @if (virhe?.laskunAvain) {
                <a [href]="'https://lemonator.lemontree.fi/asiakkaat/jzATU474P4BRCkEANZ1H/laskut/selaa/' + virhe.laskunAvain + '/' + virhe.laskunAvain" target="_blank"> Avaa lasku </a>
              }
            </li>
          }
        </ul>
      </div>
    }
  </div>
</div>
